/**
 * @file Column component for displaying a select value.
 * @author Maarten Lensink
 */
import * as tslib_1 from "tslib";
import { ChangeDetectorRef } from '@angular/core';
import { ColumnBase } from '../column-base/column-base';
import { ColumnProvider } from '../../column-provider';
import { ComponentRegistry } from '../../../core/component-registry';
/**
 * Column component for displaying a select value.
 */
var ColumnSelectComponent = /** @class */ (function (_super) {
    tslib_1.__extends(ColumnSelectComponent, _super);
    /**
     * Creates an instance of ColumnSelectComponent.
     *
     * @param {TranslateService} translateService Is needed to translate the different values.
     * @param {ColumnProvider} provider Provides the configuration information for the column.
     */
    function ColumnSelectComponent(provider, changeDetector) {
        return _super.call(this, provider, changeDetector) || this;
    }
    /**
     * Register this column class for the column provider.
     */
    ColumnSelectComponent.register = function () {
        ComponentRegistry.register('column', 'select', ColumnSelectComponent);
    };
    /**
     * This returns a boolean whether or not a value is present.
     *
     * @returns {boolean}
     */
    ColumnSelectComponent.prototype.valuePresent = function () {
        return this.provider.value != null && this.provider.field.format != null;
    };
    Object.defineProperty(ColumnSelectComponent.prototype, "labelKey", {
        /**
         * Returns the label key of the selected value.
         */
        get: function () {
            var _this = this;
            if (!this.valuePresent()) {
                return '';
            }
            var format = this.provider.field.format;
            var value = format.find(function (element) { return element.value === _this.provider.value; });
            return value ? value.labelKey : '';
        },
        enumerable: true,
        configurable: true
    });
    return ColumnSelectComponent;
}(ColumnBase));
export { ColumnSelectComponent };
